import { render, staticRenderFns } from "./QUALITY_KPI.vue?vue&type=template&id=2bbfde83&"
import script from "./QUALITY_KPI.vue?vue&type=script&lang=js&"
export * from "./QUALITY_KPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports